<!-- Modal Register Professional avec Wizard -->
<div class="register-modal-overlay" *ngIf="visible" (click)="closeModal()">
  <div class="register-modal" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    <button class="modal-close" (click)="closeModal()">
      <span class="material-icons">close</span>
    </button>

    <!-- Success Animation -->
    <div class="success-animation" *ngIf="showSuccessAnimation">
      <div class="success-checkmark">
        <span class="material-icons">check_circle</span>
      </div>
      <h3>Compte créé avec succès !</h3>
      <p>Redirection en cours...</p>
    </div>

    <!-- Modal Content -->
    <div class="modal-content" *ngIf="!showSuccessAnimation">
      <!-- Header avec Steps -->
      <div class="modal-header">
        <div class="step-indicator">
          <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
            <div class="step-circle">
              <span *ngIf="currentStep <= 1">1</span>
              <span class="material-icons" *ngIf="currentStep > 1">check</span>
            </div>
            <span class="step-label">Informations</span>
          </div>
          <div class="step-line" [class.completed]="currentStep > 1"></div>
          <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
            <div class="step-circle">
              <span *ngIf="currentStep <= 2">2</span>
              <span class="material-icons" *ngIf="currentStep > 2">check</span>
            </div>
            <span class="step-label">Sécurité</span>
          </div>
          <div class="step-line" [class.completed]="currentStep > 2"></div>
          <div class="step" [class.active]="currentStep === 3">
            <div class="step-circle">
              <span>3</span>
            </div>
            <span class="step-label">Finalisation</span>
          </div>
        </div>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form [formGroup]="registerForm">
          <!-- Step 1: Informations -->
          <div class="step-content" *ngIf="currentStep === 1">
            <h3>Créez votre compte</h3>
            <p class="step-description">Commencez par vos informations de base</p>

            <div class="form-field">
              <label for="username">Nom d'utilisateur *</label>
              <div class="input-container">
                <span class="material-icons input-icon">person</span>
                <input
                  type="text"
                  id="username"
                  formControlName="username"
                  placeholder="Votre nom d'utilisateur"
                  [class.error]="registerForm.get('username')?.invalid && registerForm.get('username')?.touched"
                />
              </div>
              <small *ngIf="registerForm.get('username')?.hasError('required') && registerForm.get('username')?.touched" 
                     class="error-text">Le nom d'utilisateur est requis</small>
              <small *ngIf="registerForm.get('username')?.hasError('minlength') && registerForm.get('username')?.touched" 
                     class="error-text">Minimum 3 caractères requis</small>
            </div>

            <div class="form-field">
              <label for="email">Email professionnel *</label>
              <div class="input-container">
                <span class="material-icons input-icon">email</span>
                <input
                  type="email"
                  id="email"
                  formControlName="email"
                  placeholder="votre@email.com"
                  [class.error]="registerForm.get('email')?.invalid && registerForm.get('email')?.touched"
                />
              </div>
              <small *ngIf="registerForm.get('email')?.hasError('required') && registerForm.get('email')?.touched" 
                     class="error-text">L'email est requis</small>
              <small *ngIf="registerForm.get('email')?.hasError('email') && registerForm.get('email')?.touched" 
                     class="error-text">Format d'email invalide</small>
            </div>

            <div class="form-field">
              <label for="telephone">Téléphone</label>
              <div class="input-container">
                <span class="material-icons input-icon">phone</span>
                <input
                  type="tel"
                  id="telephone"
                  formControlName="telephone"
                  placeholder="+33 6 12 34 56 78"
                />
              </div>
            </div>
          </div>

          <!-- Step 2: Sécurité -->
          <div class="step-content" *ngIf="currentStep === 2">
            <h3>Sécurisez votre compte</h3>
            <p class="step-description">Choisissez un mot de passe fort et sécurisé</p>

            <div class="form-field">
              <label for="password">Mot de passe *</label>
              <div class="input-container">
                <span class="material-icons input-icon">lock</span>
                <input
                  [type]="hidePassword ? 'password' : 'text'"
                  id="password"
                  formControlName="password"
                  placeholder="••••••••"
                  (input)="checkPasswordStrength()"
                  [class.error]="registerForm.get('password')?.invalid && registerForm.get('password')?.touched"
                />
                <button 
                  type="button" 
                  class="toggle-password"
                  (click)="togglePasswordVisibility()"
                >
                  <span class="material-icons">{{ hidePassword ? 'visibility' : 'visibility_off' }}</span>
                </button>
              </div>
              <small *ngIf="registerForm.get('password')?.hasError('required') && registerForm.get('password')?.touched" 
                     class="error-text">Le mot de passe est requis</small>
            </div>

            <!-- Password Strength Indicator -->
            <div class="password-strength" *ngIf="registerForm.get('password')?.value">
              <div class="strength-bar">
                <div class="strength-fill" [ngClass]="passwordStrength"></div>
              </div>
              <p class="strength-text">Force: <strong>{{ getPasswordStrengthText() }}</strong></p>
            </div>

            <!-- Password Requirements -->
            <div class="password-requirements">
              <p class="requirements-title">Le mot de passe doit contenir :</p>
              <div class="requirement" [class.met]="hasMinLength">
                <span class="material-icons">{{ hasMinLength ? 'check_circle' : 'radio_button_unchecked' }}</span>
                <span>Au moins 6 caractères</span>
              </div>
              <div class="requirement" [class.met]="hasUpperCase">
                <span class="material-icons">{{ hasUpperCase ? 'check_circle' : 'radio_button_unchecked' }}</span>
                <span>Une lettre majuscule</span>
              </div>
              <div class="requirement" [class.met]="hasLowerCase">
                <span class="material-icons">{{ hasLowerCase ? 'check_circle' : 'radio_button_unchecked' }}</span>
                <span>Une lettre minuscule</span>
              </div>
              <div class="requirement" [class.met]="hasNumber">
                <span class="material-icons">{{ hasNumber ? 'check_circle' : 'radio_button_unchecked' }}</span>
                <span>Un chiffre</span>
              </div>
            </div>
          </div>

          <!-- Step 3: Finalisation -->
          <div class="step-content" *ngIf="currentStep === 3">
            <h3>Dernière étape !</h3>
            <p class="step-description">Choisissez votre type de compte</p>

            <!-- Role Selection Cards -->
            <div class="role-selection">
              <div class="role-card" 
                   *ngFor="let role of roles"
                   [class.selected]="registerForm.get('role')?.value === role.value"
                   (click)="selectRole(role.value)">
                <span class="material-icons role-icon">{{ getRoleIcon(role.value) }}</span>
                <h4>{{ role.label }}</h4>
                <p>{{ getRoleDescription(role.value) }}</p>
              </div>
            </div>

            <!-- Summary Box -->
            <div class="summary-box">
              <h4>Récapitulatif de votre inscription</h4>
              <div class="summary-item">
                <span class="material-icons">person</span>
                <span>{{ registerForm.get('username')?.value }}</span>
              </div>
              <div class="summary-item">
                <span class="material-icons">email</span>
                <span>{{ registerForm.get('email')?.value }}</span>
              </div>
              <div class="summary-item">
                <span class="material-icons">badge</span>
                <span>{{ getRoleLabel() }}</span>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn-secondary-modal" 
          *ngIf="currentStep > 1"
          (click)="previousStep()">
          <span class="material-icons">arrow_back</span>
          Précédent
        </button>

        <button 
          type="button" 
          class="btn-primary-modal" 
          *ngIf="currentStep < 3"
          [disabled]="!canProceedToNextStep()"
          (click)="nextStep()">
          Suivant
          <span class="material-icons">arrow_forward</span>
        </button>

        <button 
          type="button" 
          class="btn-primary-modal" 
          *ngIf="currentStep === 3"
          [disabled]="!registerForm.valid || isLoading"
          (click)="onSubmit()">
          <span *ngIf="!isLoading">Créer mon compte</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>
      </div>
    </div>
  </div>
</div>